/**
 * プロダクト別試用日数（クライアント）— サーバー productTrialHelper と同一ルール
 */

export function parseProductTrialDaysOverride(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  const floored = Math.floor(n);
  if (floored < 0 || floored > 365) {
    return null;
  }
  return floored;
}

export function isProductFree(product) {
  if (!product) return false;
  return product.isFree === true || Number(product.monthlyPrice) === 0;
}

/**
 * 契約 UI 用の解決済み試用日数（0 = 試用なし）
 */
export function resolveEffectiveTrialPeriodDays(product, {
  effectiveIsBeta = false,
  hubTrialPeriodDays = 14,
  hubBetaTrialPeriodDays = 30,
} = {}) {
  if (isProductFree(product)) {
    return 0;
  }
  const hubDays = effectiveIsBeta ? hubBetaTrialPeriodDays : hubTrialPeriodDays;
  const raw = effectiveIsBeta ? product?.betaTrialPeriodDays : product?.trialPeriodDays;
  const override = parseProductTrialDaysOverride(raw);
  if (override !== null) {
    return override;
  }
  return Number(hubDays) || 0;
}

/**
 * 試用日数の補足説明（契約モーダル用。空文字のときは表示しない）
 * デフォルト試用日数は本文「本日から N 日間…」と重複するため、ハブ設定等の内部用語は出さない。
 */
export function describeTrialPeriodSource(product, { effectiveIsBeta = false } = {}) {
  if (isProductFree(product)) {
    return '無料製品のため試用期間はありません。';
  }
  if (effectiveIsBeta) {
    const override = parseProductTrialDaysOverride(product?.betaTrialPeriodDays);
    if (override !== null) {
      return override === 0
        ? 'この製品は試用期間がないため、契約後すぐに課金が始まります。'
        : '';
    }
    return '';
  }
  const override = parseProductTrialDaysOverride(product?.trialPeriodDays);
  if (override !== null) {
    return override === 0
      ? 'この製品は試用期間がないため、契約後すぐに課金が始まります。'
      : '';
  }
  return '';
}
